<template>
  <div class="wrap">
    <div class="pop-guide show">
      <div class="box">
        <div class="hd">
          <span>{{ titleText }}</span>
        </div>
        <div class="bd">
          <router-view ref="main" @orderPayShow="orderPayShow" @orderPayWeixinGuideShow="orderPayWeixinGuideShow" />
        </div>
      </div>
    </div>
    <pay-box ref="dialogpay" @payCompleted="payCompleted"></pay-box>
  </div>
</template>

<script>
import {
  userInfo,
  consumeFCode,
  getFCode,
  getFCodeName,
  getUserRobots,
  getWechatSdk,
  getRoomName,
  getAgentdata,
  createWechatPayOrder,
  createWechatPay,
  checkFcodeOrder,
  checkFreeState
} from '@/api/index'
import { Message } from 'element-ui'
import { mapState, mapActions, mapMutations } from 'vuex'
import payBox from '@/components/payBox'
import { commonFuc } from '@/mixins/commonFuc'
export default {
  mixins: [commonFuc],
  data() {
    return {
      isShowMenu: false,
      dialogShowInputFCode: false,
      ticket: '',
      formData: {
        FCode: ''
      },
      pName: '',
      orderPayType: 'normal'
      // robotLabel: ""
    }
  },
  components: {
    payBox
  },
  computed: {
    ...mapState({
      isPC: state => state.isPC,
      isWeixin: state => state.isWeixin,
      user: state => state.user,
      robotList: state => state.robotList,
      agentType: state => state.agentType,
      canFree:state => state.canFree
    }),
    titleText() {
      let title = ''
      if (this.$route.path == '/renew') {
        title = '续费功能'
      }
      if (this.$route.path == '/guideFcode') {
        title = '激活商业版'
      }
      if (this.$route.path == '/guideAccount') {
        title = '场控配置'
      }
      if (this.$route.path == '/guideRate') {
        title = '主要设定'
      }
      if (this.$route.path == '/guideContent') {
        title = '内容配置'
      }
      if (this.$route.path == '/guideError') {
        title = '下载客户端'
      }
      if (this.$route.path == '/contact') {
        title = '联系客服'
      }
      if (this.$route.path == '/agent') {
        title = '推广返现'
      }
      if (this.$route.path == '/details') {
        title = '佣金明细'
      }
      if (this.$route.path == '/promoters') {
        title = '代理商'
      }

      return title
    }
  },
  created() {
    this.checkFreeState();
  },
  mounted() {
    this.changeLoadingStatus(true)
    userInfo(null, { notify: false }).then(res => {
      if (res.code == -2050) {
        localStorage.removeItem('sid')
        if (this.$route.path != '/agent' && this.$route.path != '/login') {
          this.$router.replace('/login')
        }
      } else {
        // this.user = res.data;
        this.ticket = res.data.ticket
        this.updateUser(res.data)
      }
      this.changeLoadingStatus(false)
    })
    if (this.isWeixin) {
      getWechatSdk(
        {
          url: location.href
        },
        { notify: false }
      ).then(res => {
        let data = res.data
        wx.config({
          debug: data.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList
        })
      })
    }
  },
  methods: {
    ...mapActions(['updateUser', 'changeLoadingStatus']),
    ...mapMutations(['UPDATE_FREE_DATA']),
    async checkFreeState(){
      let ret =await checkFreeState();
      if(ret && ret.code === 0){
        this.UPDATE_FREE_DATA(ret.data.state)
      }
    },
    logout() {
      localStorage.removeItem('sid')
      localStorage.removeItem('avatar')
      localStorage.removeItem('user_name')
      this.$router.replace('/login')
    },
    orderPayShow(json, orderpaytype = 'normal') {
      console.log(json)
      let self = this
      json.ticket = this.ticket
      this.orderPayType = orderpaytype
      if (this.isWeixin && !this.isPC) {
        createWechatPayOrder(json).then(res => {
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>'
            })
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>'
            })
          }
          let orderId = res.data.orderId
          createWechatPay({
            order_id: orderId
          }).then(payData => {
            if (payData.code == 70003) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message:
                  '<strong>微信登录授权过期</strong><p style="margin-top: 5px;">请刷新，重新登录配置后台</p>'
              })
            }
            if (payData.code == 1000) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message:
                  '<strong>创建公众号订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>'
              })
            }
            if (payData.code == 0) {
              let data = payData.data
              wx.chooseWXPay({
                timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function(res) {
                  // 支付成功后的回调函数
                  self.checkFcodeOrder(orderId)
                }
              })
            }
          })
        })
        return
      }
      setTimeout(() => {
        this.$refs.dialogpay.showDialog(json)
      }, 0)
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder(
        {
          orderId: orderId
        },
        { notify: false }
      ).then(res => {
        if (res.code === 0) {
          if (res.data.paid) {
            this.$refs.main.orderCheckResult(res.data.fcodes)
          }
        }
      })
    },
    payCompleted(fcode, pkey = '') {
      if (this.orderPayType == 'fcode') {
        this.$refs.main.payCompleted(fcode, pkey)
      }
    }
  }
}
</script>
